import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { FormSelect } from '@getro/rombo';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';

const reviewStatusOptions = [
  { label: 'Any', value: '' },
  { label: 'Reviewed', value: 'reviewed' },
  { label: 'To review', value: 'pending_review' },
];

export const ReviewStatusFilter = ({ value, setFilters }) => {
  const onSubmit = ({ reviewStatus }) => {
    const reviewStatusValue = reviewStatus?.value || reviewStatus || '';
    setFilters({ reviewStatus: reviewStatusValue });
  };

  const selectedValue = reviewStatusOptions.find((opt) => opt.value === value) || reviewStatusOptions[0];

  return (
    <Formik initialValues={{ reviewStatus: selectedValue }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="reviewStatus"
          label="Review status"
          placeholder="Any"
          component={FormSelect}
          options={reviewStatusOptions}
          size="small"
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

ReviewStatusFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
};

ReviewStatusFilter.defaultProps = {
  value: '',
};
